<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99968 1.33325C6.68113 1.33325 5.3922 1.72425 4.29588 2.45679C3.19955 3.18933 2.34506 4.23052 1.84048 5.44869C1.3359 6.66687 1.20387 8.00731 1.46111 9.30052C1.71834 10.5937 2.35328 11.7816 3.28563 12.714C4.21798 13.6463 5.40587 14.2812 6.69907 14.5385C7.99228 14.7957 9.33272 14.6637 10.5509 14.1591C11.7691 13.6545 12.8103 12.8 13.5428 11.7037C14.2753 10.6074 14.6663 9.31846 14.6663 7.99992C14.6645 6.23238 13.9615 4.53777 12.7117 3.28793C11.4618 2.0381 9.76721 1.33512 7.99968 1.33325ZM13.6407 7.99992C13.642 9.31885 13.1788 10.5961 12.3324 11.6076L4.39198 3.66658C5.2157 2.98131 6.21755 2.54482 7.2803 2.40817C8.34305 2.27153 9.42273 2.44039 10.393 2.895C11.3633 3.34961 12.184 4.07115 12.7592 4.97521C13.3343 5.87926 13.6401 6.92842 13.6407 7.99992ZM2.35865 7.99992C2.35734 6.68099 2.82054 5.40372 3.66698 4.39223L11.6074 12.3333C10.7837 13.0185 9.7818 13.455 8.71905 13.5917C7.6563 13.7283 6.57662 13.5594 5.60634 13.1048C4.63606 12.6502 3.81533 11.9287 3.24018 11.0246C2.66503 10.1206 2.35926 9.07141 2.35865 7.99992Z"
      fill="#F03800"
    />
  </svg>
</template>
